// SPDX-FileCopyrightText: Copyright Orangebot, Inc. and Medplum contributors
// SPDX-License-Identifier: Apache-2.0
import { Alert } from '@mantine/core';
import type { Patient } from '@medplum/fhirtypes';
import { IconAlertCircle } from '@tabler/icons-react';
import type { JSX } from 'react';
import { useState } from 'react';
import { useOutstandingBalance } from '../../../hooks/useOutstandingBalance';

export interface OutstandingBalanceAlertProps {
  patient: Patient;
  /** Test-only override to force the alert visible regardless of the hook. */
  forceVisible?: boolean;
}

export function OutstandingBalanceAlert({ patient, forceVisible }: OutstandingBalanceAlertProps): JSX.Element | null {
  const hasBalance = useOutstandingBalance(patient);
  const [dismissed, setDismissed] = useState(false);

  if (dismissed || (!forceVisible && !hasBalance)) {
    return null;
  }

  return (
    <Alert
      icon={<IconAlertCircle size={18} />}
      color="red"
      variant="filled"
      title="Outstanding Balance"
      withCloseButton
      closeButtonLabel="Dismiss outstanding balance alert"
      onClose={() => setDismissed(true)}
    >
      This patient has an overdue payment.
    </Alert>
  );
}
